import React, { useEffect, useState } from 'react';

// UTILS
import { getInitialsFromEmail, resolveAvatar } from 'utils/avatar';

const Avatar = ({ email, alt = 'Avatar', className = 'size-8', rounded = true }) => {
    const [error, setError] = useState(false);
    const [resolved, setResolved] = useState(null);
    const radius = rounded ? 'rounded-full' : '';

    useEffect(() => {
        let isMounted = true;
        setError(false);
        setResolved(null);
        if (!email) return;
        resolveAvatar(email).then((res) => {
            if (isMounted) setResolved(res);
        });
        return () => { isMounted = false; };
    }, [email]);

    if (!email || error || resolved?.type === 'initials') {
        return (
            <div className={`${className} ${radius} bg-gris-clair dark:bg-dark flex items-center justify-center text-dark dark:text-blanc font-semibold select-none uppercase`}>
                {getInitialsFromEmail(email)}
            </div>
        );
    }

    const src = resolved?.src || `${process.env.REACT_APP_URL_SSO}/avatar/${email}`;

    return (
        <img
            src={src}
            alt={alt}
            className={`${className} ${radius}`}
            onError={() => setError(true)}
        />
    );
};

export default Avatar;


